import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Button as AntdButton, Flex, Form, Select, message } from 'antd';
import Icon from '../../../../../components/common/Icon';
import { LeftPanel, LeftPanelCard, LeftPanelCardBody, LeftPanelCardFooter, LeftPanelCardHead, LeftPanelContainer, } from '../../../editor.style';
import { useDispatch, useSelector } from 'react-redux';
import { updateSiteAction } from '../../../../../store/siteSlice';
import { getSiteLanguagesAction } from '../../../../../store/mutliLanguageSlice';
const AddLanguageFormPanel = ({ isOpen, onBack }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    // Retrieve supported languages
    const supportedLanguagesResponse = useSelector((state) => state.multiLanguage.getSupportedLanguages.response) ||
        {};
    // Remove English
    const { en, ...supportedLanguages } = supportedLanguagesResponse;
    // Get existing site languages
    const multiLanguages = useSelector((state) => state.multiLanguage.getSiteLanguages.response?.content) || [];
    const preSelectedCodes = multiLanguages.map((lang) => lang.destinationLanguage);
    // Get the current site ID.
    const siteId = useSelector((state) => state.site.checkSite.response?.data?.siteId);
    //site data to the current lat and lng // Todo : Remove after be bug is fixed
    const siteData = useSelector((state) => state?.site?.checkSite?.response?.data);
    // Build select options from the supported languages lookup.
    const selectOptions = Object.entries(supportedLanguages).map(([key, value]) => ({
        label: value,
        value: key,
    }));
    // Prepare the payload
    const prepareSiteLanguages = (selectedCodes) => {
        const languagesPayload = selectedCodes.map((code) => ({
            name: supportedLanguages[code] || code,
            code,
            enabled: true,
            default: false,
        }));
        languagesPayload.unshift({
            name: en || 'English',
            code: 'en',
            enabled: true,
            default: true,
        });
        return languagesPayload;
    };
    // onFinish handler
    const onFinish = async (values) => {
        setLoading(true);
        try {
            const selectedLanguageCodes = values.language;
            const languagesPayload = prepareSiteLanguages(selectedLanguageCodes);
            //added lat lng to the payload bcz of be bug
            const data = { languages: languagesPayload, latitude: siteData?.latitude, longitude: siteData?.longitude };
            await dispatch(updateSiteAction({ siteId, data }));
            await dispatch(getSiteLanguagesAction(siteId || ''));
            message.success('Language updated successfully');
            form.resetFields();
            onBack();
        }
        catch (error) {
            message.error('Error updating site languages');
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsx(LeftPanel, { isOpen: isOpen, style: { width: '340px' }, children: _jsx(LeftPanelContainer, { children: _jsxs(LeftPanelCard, { children: [_jsx(LeftPanelCardHead, { children: _jsxs(Flex, { align: "center", children: [_jsx(AntdButton, { style: { marginLeft: '-8px' }, variant: "text", icon: _jsx(Icon, { icon: "arrow-left", size: 18 }), onClick: () => {
                                        onBack();
                                        form.resetFields();
                                    } }), _jsx("h3", { children: "Add or Remove Languages" })] }) }), _jsx(LeftPanelCardBody, { style: { padding: '0 16px 16px' }, children: _jsx(Form, { form: form, onFinish: onFinish, initialValues: { language: preSelectedCodes }, layout: "vertical", children: _jsx(Form.Item, { name: "language", label: "Select Language", required: true, rules: [{ required: true, message: 'Please select a language' }], children: _jsx(Select, { placeholder: "Choose Language", mode: "multiple", options: selectOptions, showSearch: true }) }) }) }), _jsxs(LeftPanelCardFooter, { children: [_jsx(AntdButton, { onClick: () => {
                                    onBack();
                                    form.resetFields();
                                }, color: "danger", variant: "filled", children: "Cancel" }), _jsx(AntdButton, { loading: loading, onClick: () => form.submit(), color: "primary", variant: "solid", children: "Add" })] })] }) }) }));
};
export default React.memo(AddLanguageFormPanel);
